import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setReviewerViewSettings, useReviewersSettings } from 'reducers/reviewCreationSlice';

import { ReceiverManager1 } from 'assets/assetsV1/iconComponents';
import DLMReview from 'assets/assetsV1/illustrations/DLMReview.png';
import ManagerReview from 'assets/assetsV1/illustrations/managerReview.png';
import PeerReview from 'assets/assetsV1/illustrations/peerReview.png';
import SelfReview from 'assets/assetsV1/illustrations/selfReview.png';
import UpwardReview from 'assets/assetsV1/illustrations/upwardReview.png';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { CheckboxCard } from 'uiToolkitV1/CheckboxCard/CheckboxCard';
import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';

export const ReviewersSection = ({ view, feedbackFormId }) => {
  const dispatch = useDispatch();
  const { enabledProviderTypes } = useReviewersSettings({ feedbackFormId });

  const onChangeHandler = (type) => {
    const newEnabledProviderTypes = enabledProviderTypes.includes(type)
      ? enabledProviderTypes.filter((item) => item !== type)
      : [...enabledProviderTypes, type];
    dispatch(
      setReviewerViewSettings({
        feedbackFormId,
        settings: { enabledProviderTypes: newEnabledProviderTypes },
      })
    );
  };

  return (
    <ExpandablePaper>
      <ExpandablePaperHeader
        title="Select the types of reviewers who will review the employee"
        leftIconComponent={<ReceiverManager1 boxSize="24px" color="icon.g2" />}
      />
      <ExpandablePaperBody>
        <Flex gap={3} flexWrap="wrap">
          <CheckboxCard
            title="Self Review"
            subText="Process of evaluating oneself "
            imgSrc={SelfReview}
            checked={enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.SELF)}
            onClick={() => {
              onChangeHandler(REVIEW_PROVIDER_TYPES.SELF);
            }}
            isDisabled
          />
          <CheckboxCard
            title="Manager Review"
            subText="Process of evaluating  your direct reportees"
            imgSrc={ManagerReview}
            checked={enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.MANAGER)}
            onClick={() => {
              onChangeHandler(REVIEW_PROVIDER_TYPES.MANAGER);
            }}
            isDisabled
          />
          <CheckboxCard
            title="Dotted Line Manager"
            subText="Process of evaluating your dotted line reports"
            imgSrc={DLMReview}
            checked={enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.DLM)}
            onClick={() => {
              onChangeHandler(REVIEW_PROVIDER_TYPES.DLM);
            }}
            imgProps={{
              fit: 'cover',
            }}
          />
          <CheckboxCard
            title="Peer Review"
            subText="Process of evaluating your co-workers"
            imgSrc={PeerReview}
            checked={enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.PEER)}
            onClick={() => {
              onChangeHandler(REVIEW_PROVIDER_TYPES.PEER);
            }}
          />
          <CheckboxCard
            title="Upward Review"
            subText="Process of evaluating your direct managers"
            imgSrc={UpwardReview}
            checked={enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.UPWARD)}
            onClick={() => {
              onChangeHandler(REVIEW_PROVIDER_TYPES.UPWARD);
            }}
          />
        </Flex>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
